<template>
    <div style="text-align: center;margin-top: 200px">
        <div style="margin-bottom: 20px;font-size: 20px">
            支付失败
        </div>

        <a href="/" class="back_to_home_button">
            返回首页
        </a>
    </div>
</template>

<script>
    export default {
        name: "fail"
    }
</script>

<style scoped>
    .back_to_home_button {
        color: #fff;
        border-color: #66CCFF;
        background-color: #66CCFF;
        border: 1px solid transparent;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .back_to_home_button:hover {
        color: #fff;
        border-color: #069a75;
        background-color: #069a75;;
    }

</style>